import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import { ActivityTemplateInterface } from "../../Entity/Entities/Activity/ActivityTemplateInterface";

class ActivityTemplateUpdateWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.id, 10);
    const activityTemplate = this.component.props.app.activityTemplates.filter((activityTemplate: ActivityTemplateInterface) => activityTemplate.id === id)[0];
    this.component.session = this.component.props.app.session.user;
    this.component.person = this.component.props.app.persons.filter(
      person => person.id === this.component.session.id
    )[0];

    if (!activityTemplate) {
      return this.component.redirectBack();
    }

    this.component.props.dispatch({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_UPDATE_CLEAR
    });

    this.component.activityTemplate = activityTemplate;

    const taskTemplates = [...activityTemplate.taskTemplates]
      .reverse()
      .sort((task1, task2) => {
        if (task1.data.name.toLowerCase() > task2.data.name.toLowerCase()) {
          return 1;
        }

        if (task1.data.name.toLowerCase() < task2.data.name.toLowerCase()) {
          return -1;
        }

        return  0;
      });

    let state: any = {
      name: activityTemplate.name,
      taskTemplates: taskTemplates,
      activeTemplate: activityTemplate.taskTemplates.length > 0 ? taskTemplates[0] : null
    };

    let savedDataBeforeRedirecting: any = {};

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdExecutor = this.component.props.app.savedDataBeforeRedirecting.executor &&
        this.component.props.app.savedDataBeforeRedirecting.executor;

      savedDataBeforeRedirecting = {
        ...this.component.props.app.savedDataBeforeRedirecting.activityTemplateUpdateDataToBeSaved,
      };

      if (!!createdExecutor && !!savedDataBeforeRedirecting.activeTemplate) {
        savedDataBeforeRedirecting.activeTemplate.data.executorId = createdExecutor.id;
      }
    }

    this.component.setState({
      ...state,
      ...savedDataBeforeRedirecting
    });
  }
}

export default new ActivityTemplateUpdateWillMount();
